/**
 * Generated by orval v7.5.0 🍺
 * Do not edit manually.
 * Template API
 * Something something. <br><br>The spec is available at <a href='/swagger/api.json'>/swagger/api.json</a>.
 * OpenAPI spec version: 0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  ApiAppError,
  BrowseBookingResponse,
  CopyBookingBulkRequest,
  CopyBookingBulkResponse,
  CreateBookingRequest,
  CreateBookingResponse,
  CreateInvoiceResponse,
  GetBookingResponse,
  GetBookingsParams,
  GetBookingsResponse,
  UpdateBookingChangeDepartmentRequest,
  UpdateBookingChangeStatusRequest,
  UpdateBookingGroupInformationRequest,
  UpdateBookingResponse,
  UpdateBookingSendExternalBookingRequest,
  UpdateBookingSendInternalBookingRequest,
  UpdateBookingUpdateDetailedInformationRequest,
  UpdateBookingUpdateProgramRequest,
  UpdateBookingUpdateVisitInformationRequest
} from './schemas'
import { getApi } from '../client';
import type { ErrorType, BodyType } from '../client';



type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * @summary Create Booking
 */
export const createBooking = (
    createBookingRequest: BodyType<CreateBookingRequest>,
 options?: SecondParameter<typeof getApi>,signal?: AbortSignal
) => {
      
      
      return getApi<CreateBookingResponse>(
      {url: `/booking`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createBookingRequest, signal
    },
      options);
    }
  


export const getCreateBookingMutationOptions = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBooking>>, TError,{data: BodyType<CreateBookingRequest>}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationOptions<Awaited<ReturnType<typeof createBooking>>, TError,{data: BodyType<CreateBookingRequest>}, TContext> => {
    
const mutationKey = ['createBooking'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBooking>>, {data: BodyType<CreateBookingRequest>}> = (props) => {
          const {data} = props ?? {};

          return  createBooking(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateBookingMutationResult = NonNullable<Awaited<ReturnType<typeof createBooking>>>
    export type CreateBookingMutationBody = BodyType<CreateBookingRequest>
    export type CreateBookingMutationError = ErrorType<ApiAppError>

    /**
 * @summary Create Booking
 */
export const useCreateBooking = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBooking>>, TError,{data: BodyType<CreateBookingRequest>}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationResult<
        Awaited<ReturnType<typeof createBooking>>,
        TError,
        {data: BodyType<CreateBookingRequest>},
        TContext
      > => {

      const mutationOptions = getCreateBookingMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get Booking
 */
export const getBooking = (
    id: number,
 options?: SecondParameter<typeof getApi>,signal?: AbortSignal
) => {
      
      
      return getApi<GetBookingResponse>(
      {url: `/booking/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetBookingQueryKey = (id: number,) => {
    return [`/booking/${id}`] as const;
    }

    
export const getGetBookingQueryOptions = <TData = Awaited<ReturnType<typeof getBooking>>, TError = ErrorType<ApiAppError>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBooking>>, TError, TData>>, request?: SecondParameter<typeof getApi>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBookingQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBooking>>> = ({ signal }) => getBooking(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBooking>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBookingQueryResult = NonNullable<Awaited<ReturnType<typeof getBooking>>>
export type GetBookingQueryError = ErrorType<ApiAppError>


export function useGetBooking<TData = Awaited<ReturnType<typeof getBooking>>, TError = ErrorType<ApiAppError>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBooking>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBooking>>,
          TError,
          Awaited<ReturnType<typeof getBooking>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApi>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBooking<TData = Awaited<ReturnType<typeof getBooking>>, TError = ErrorType<ApiAppError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBooking>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBooking>>,
          TError,
          Awaited<ReturnType<typeof getBooking>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApi>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBooking<TData = Awaited<ReturnType<typeof getBooking>>, TError = ErrorType<ApiAppError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBooking>>, TError, TData>>, request?: SecondParameter<typeof getApi>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Booking
 */

export function useGetBooking<TData = Awaited<ReturnType<typeof getBooking>>, TError = ErrorType<ApiAppError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBooking>>, TError, TData>>, request?: SecondParameter<typeof getApi>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBookingQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get Booking
 */
export const prefetchGetBooking = async <TData = Awaited<ReturnType<typeof getBooking>>, TError = ErrorType<ApiAppError>>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBooking>>, TError, TData>>, request?: SecondParameter<typeof getApi>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetBookingQueryOptions(id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}


/**
 * @summary Copy Booking in bulk
 */
export const copyBookinginbulk = (
    id: number,
    copyBookingBulkRequest: BodyType<CopyBookingBulkRequest>,
 options?: SecondParameter<typeof getApi>,signal?: AbortSignal
) => {
      
      
      return getApi<CopyBookingBulkResponse>(
      {url: `/booking/${id}/bulkcopy`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: copyBookingBulkRequest, signal
    },
      options);
    }
  


export const getCopyBookinginbulkMutationOptions = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof copyBookinginbulk>>, TError,{id: number;data: BodyType<CopyBookingBulkRequest>}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationOptions<Awaited<ReturnType<typeof copyBookinginbulk>>, TError,{id: number;data: BodyType<CopyBookingBulkRequest>}, TContext> => {
    
const mutationKey = ['copyBookinginbulk'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof copyBookinginbulk>>, {id: number;data: BodyType<CopyBookingBulkRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  copyBookinginbulk(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CopyBookinginbulkMutationResult = NonNullable<Awaited<ReturnType<typeof copyBookinginbulk>>>
    export type CopyBookinginbulkMutationBody = BodyType<CopyBookingBulkRequest>
    export type CopyBookinginbulkMutationError = ErrorType<ApiAppError>

    /**
 * @summary Copy Booking in bulk
 */
export const useCopyBookinginbulk = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof copyBookinginbulk>>, TError,{id: number;data: BodyType<CopyBookingBulkRequest>}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationResult<
        Awaited<ReturnType<typeof copyBookinginbulk>>,
        TError,
        {id: number;data: BodyType<CopyBookingBulkRequest>},
        TContext
      > => {

      const mutationOptions = getCopyBookinginbulkMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Copy Booking
 */
export const copyBooking = (
    id: string,
 options?: SecondParameter<typeof getApi>,signal?: AbortSignal
) => {
      
      
      return getApi<void>(
      {url: `/booking/${id}/copy`, method: 'POST', signal
    },
      options);
    }
  


export const getCopyBookingMutationOptions = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof copyBooking>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationOptions<Awaited<ReturnType<typeof copyBooking>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['copyBooking'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof copyBooking>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  copyBooking(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CopyBookingMutationResult = NonNullable<Awaited<ReturnType<typeof copyBooking>>>
    
    export type CopyBookingMutationError = ErrorType<ApiAppError>

    /**
 * @summary Copy Booking
 */
export const useCopyBooking = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof copyBooking>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationResult<
        Awaited<ReturnType<typeof copyBooking>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getCopyBookingMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Change Booking Department
 */
export const changeBookingDepartment = (
    id: number,
    updateBookingChangeDepartmentRequest: BodyType<UpdateBookingChangeDepartmentRequest>,
 options?: SecondParameter<typeof getApi>,) => {
      
      
      return getApi<UpdateBookingResponse>(
      {url: `/booking/${id}/department`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateBookingChangeDepartmentRequest
    },
      options);
    }
  


export const getChangeBookingDepartmentMutationOptions = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeBookingDepartment>>, TError,{id: number;data: BodyType<UpdateBookingChangeDepartmentRequest>}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationOptions<Awaited<ReturnType<typeof changeBookingDepartment>>, TError,{id: number;data: BodyType<UpdateBookingChangeDepartmentRequest>}, TContext> => {
    
const mutationKey = ['changeBookingDepartment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changeBookingDepartment>>, {id: number;data: BodyType<UpdateBookingChangeDepartmentRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  changeBookingDepartment(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChangeBookingDepartmentMutationResult = NonNullable<Awaited<ReturnType<typeof changeBookingDepartment>>>
    export type ChangeBookingDepartmentMutationBody = BodyType<UpdateBookingChangeDepartmentRequest>
    export type ChangeBookingDepartmentMutationError = ErrorType<ApiAppError>

    /**
 * @summary Change Booking Department
 */
export const useChangeBookingDepartment = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeBookingDepartment>>, TError,{id: number;data: BodyType<UpdateBookingChangeDepartmentRequest>}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationResult<
        Awaited<ReturnType<typeof changeBookingDepartment>>,
        TError,
        {id: number;data: BodyType<UpdateBookingChangeDepartmentRequest>},
        TContext
      > => {

      const mutationOptions = getChangeBookingDepartmentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Update Booking Detailed Information
 */
export const updateBookingDetailedInformation = (
    id: number,
    updateBookingUpdateDetailedInformationRequest: BodyType<UpdateBookingUpdateDetailedInformationRequest>,
 options?: SecondParameter<typeof getApi>,) => {
      
      
      return getApi<UpdateBookingResponse>(
      {url: `/booking/${id}/detailed_information`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateBookingUpdateDetailedInformationRequest
    },
      options);
    }
  


export const getUpdateBookingDetailedInformationMutationOptions = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBookingDetailedInformation>>, TError,{id: number;data: BodyType<UpdateBookingUpdateDetailedInformationRequest>}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationOptions<Awaited<ReturnType<typeof updateBookingDetailedInformation>>, TError,{id: number;data: BodyType<UpdateBookingUpdateDetailedInformationRequest>}, TContext> => {
    
const mutationKey = ['updateBookingDetailedInformation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateBookingDetailedInformation>>, {id: number;data: BodyType<UpdateBookingUpdateDetailedInformationRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateBookingDetailedInformation(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateBookingDetailedInformationMutationResult = NonNullable<Awaited<ReturnType<typeof updateBookingDetailedInformation>>>
    export type UpdateBookingDetailedInformationMutationBody = BodyType<UpdateBookingUpdateDetailedInformationRequest>
    export type UpdateBookingDetailedInformationMutationError = ErrorType<ApiAppError>

    /**
 * @summary Update Booking Detailed Information
 */
export const useUpdateBookingDetailedInformation = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBookingDetailedInformation>>, TError,{id: number;data: BodyType<UpdateBookingUpdateDetailedInformationRequest>}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateBookingDetailedInformation>>,
        TError,
        {id: number;data: BodyType<UpdateBookingUpdateDetailedInformationRequest>},
        TContext
      > => {

      const mutationOptions = getUpdateBookingDetailedInformationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Update Booking Group Information
 */
export const updateBookingGroupInformation = (
    id: number,
    updateBookingGroupInformationRequest: BodyType<UpdateBookingGroupInformationRequest>,
 options?: SecondParameter<typeof getApi>,) => {
      
      
      return getApi<UpdateBookingResponse>(
      {url: `/booking/${id}/group_information`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateBookingGroupInformationRequest
    },
      options);
    }
  


export const getUpdateBookingGroupInformationMutationOptions = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBookingGroupInformation>>, TError,{id: number;data: BodyType<UpdateBookingGroupInformationRequest>}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationOptions<Awaited<ReturnType<typeof updateBookingGroupInformation>>, TError,{id: number;data: BodyType<UpdateBookingGroupInformationRequest>}, TContext> => {
    
const mutationKey = ['updateBookingGroupInformation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateBookingGroupInformation>>, {id: number;data: BodyType<UpdateBookingGroupInformationRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateBookingGroupInformation(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateBookingGroupInformationMutationResult = NonNullable<Awaited<ReturnType<typeof updateBookingGroupInformation>>>
    export type UpdateBookingGroupInformationMutationBody = BodyType<UpdateBookingGroupInformationRequest>
    export type UpdateBookingGroupInformationMutationError = ErrorType<ApiAppError>

    /**
 * @summary Update Booking Group Information
 */
export const useUpdateBookingGroupInformation = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBookingGroupInformation>>, TError,{id: number;data: BodyType<UpdateBookingGroupInformationRequest>}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateBookingGroupInformation>>,
        TError,
        {id: number;data: BodyType<UpdateBookingGroupInformationRequest>},
        TContext
      > => {

      const mutationOptions = getUpdateBookingGroupInformationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Create Invoice draft in PowerOffice
 */
export const createInvoicedraftinPowerOffice = (
    id: string,
 options?: SecondParameter<typeof getApi>,signal?: AbortSignal
) => {
      
      
      return getApi<CreateInvoiceResponse>(
      {url: `/booking/${id}/invoice`, method: 'POST', signal
    },
      options);
    }
  


export const getCreateInvoicedraftinPowerOfficeMutationOptions = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInvoicedraftinPowerOffice>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationOptions<Awaited<ReturnType<typeof createInvoicedraftinPowerOffice>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['createInvoicedraftinPowerOffice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createInvoicedraftinPowerOffice>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  createInvoicedraftinPowerOffice(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateInvoicedraftinPowerOfficeMutationResult = NonNullable<Awaited<ReturnType<typeof createInvoicedraftinPowerOffice>>>
    
    export type CreateInvoicedraftinPowerOfficeMutationError = ErrorType<ApiAppError>

    /**
 * @summary Create Invoice draft in PowerOffice
 */
export const useCreateInvoicedraftinPowerOffice = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInvoicedraftinPowerOffice>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationResult<
        Awaited<ReturnType<typeof createInvoicedraftinPowerOffice>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getCreateInvoicedraftinPowerOfficeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Update Booking Program
 */
export const updateBookingProgram = (
    id: number,
    updateBookingUpdateProgramRequest: BodyType<UpdateBookingUpdateProgramRequest>,
 options?: SecondParameter<typeof getApi>,) => {
      
      
      return getApi<UpdateBookingResponse>(
      {url: `/booking/${id}/program`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateBookingUpdateProgramRequest
    },
      options);
    }
  


export const getUpdateBookingProgramMutationOptions = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBookingProgram>>, TError,{id: number;data: BodyType<UpdateBookingUpdateProgramRequest>}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationOptions<Awaited<ReturnType<typeof updateBookingProgram>>, TError,{id: number;data: BodyType<UpdateBookingUpdateProgramRequest>}, TContext> => {
    
const mutationKey = ['updateBookingProgram'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateBookingProgram>>, {id: number;data: BodyType<UpdateBookingUpdateProgramRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateBookingProgram(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateBookingProgramMutationResult = NonNullable<Awaited<ReturnType<typeof updateBookingProgram>>>
    export type UpdateBookingProgramMutationBody = BodyType<UpdateBookingUpdateProgramRequest>
    export type UpdateBookingProgramMutationError = ErrorType<ApiAppError>

    /**
 * @summary Update Booking Program
 */
export const useUpdateBookingProgram = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBookingProgram>>, TError,{id: number;data: BodyType<UpdateBookingUpdateProgramRequest>}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateBookingProgram>>,
        TError,
        {id: number;data: BodyType<UpdateBookingUpdateProgramRequest>},
        TContext
      > => {

      const mutationOptions = getUpdateBookingProgramMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Send Booking Externally
 */
export const sendBookingExternally = (
    id: number,
    updateBookingSendExternalBookingRequest: BodyType<UpdateBookingSendExternalBookingRequest>,
 options?: SecondParameter<typeof getApi>,signal?: AbortSignal
) => {
      
      
      return getApi<UpdateBookingResponse>(
      {url: `/booking/${id}/send/externally`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateBookingSendExternalBookingRequest, signal
    },
      options);
    }
  


export const getSendBookingExternallyMutationOptions = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendBookingExternally>>, TError,{id: number;data: BodyType<UpdateBookingSendExternalBookingRequest>}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationOptions<Awaited<ReturnType<typeof sendBookingExternally>>, TError,{id: number;data: BodyType<UpdateBookingSendExternalBookingRequest>}, TContext> => {
    
const mutationKey = ['sendBookingExternally'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendBookingExternally>>, {id: number;data: BodyType<UpdateBookingSendExternalBookingRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  sendBookingExternally(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendBookingExternallyMutationResult = NonNullable<Awaited<ReturnType<typeof sendBookingExternally>>>
    export type SendBookingExternallyMutationBody = BodyType<UpdateBookingSendExternalBookingRequest>
    export type SendBookingExternallyMutationError = ErrorType<ApiAppError>

    /**
 * @summary Send Booking Externally
 */
export const useSendBookingExternally = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendBookingExternally>>, TError,{id: number;data: BodyType<UpdateBookingSendExternalBookingRequest>}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationResult<
        Awaited<ReturnType<typeof sendBookingExternally>>,
        TError,
        {id: number;data: BodyType<UpdateBookingSendExternalBookingRequest>},
        TContext
      > => {

      const mutationOptions = getSendBookingExternallyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Send Booking Internally
 */
export const sendBookingInternally = (
    id: number,
    updateBookingSendInternalBookingRequest: BodyType<UpdateBookingSendInternalBookingRequest>,
 options?: SecondParameter<typeof getApi>,signal?: AbortSignal
) => {
      
      
      return getApi<UpdateBookingResponse>(
      {url: `/booking/${id}/send/internally`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateBookingSendInternalBookingRequest, signal
    },
      options);
    }
  


export const getSendBookingInternallyMutationOptions = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendBookingInternally>>, TError,{id: number;data: BodyType<UpdateBookingSendInternalBookingRequest>}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationOptions<Awaited<ReturnType<typeof sendBookingInternally>>, TError,{id: number;data: BodyType<UpdateBookingSendInternalBookingRequest>}, TContext> => {
    
const mutationKey = ['sendBookingInternally'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendBookingInternally>>, {id: number;data: BodyType<UpdateBookingSendInternalBookingRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  sendBookingInternally(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendBookingInternallyMutationResult = NonNullable<Awaited<ReturnType<typeof sendBookingInternally>>>
    export type SendBookingInternallyMutationBody = BodyType<UpdateBookingSendInternalBookingRequest>
    export type SendBookingInternallyMutationError = ErrorType<ApiAppError>

    /**
 * @summary Send Booking Internally
 */
export const useSendBookingInternally = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendBookingInternally>>, TError,{id: number;data: BodyType<UpdateBookingSendInternalBookingRequest>}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationResult<
        Awaited<ReturnType<typeof sendBookingInternally>>,
        TError,
        {id: number;data: BodyType<UpdateBookingSendInternalBookingRequest>},
        TContext
      > => {

      const mutationOptions = getSendBookingInternallyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Change Booking Status
 */
export const changeBookingStatus = (
    id: number,
    updateBookingChangeStatusRequest: BodyType<UpdateBookingChangeStatusRequest>,
 options?: SecondParameter<typeof getApi>,) => {
      
      
      return getApi<UpdateBookingResponse>(
      {url: `/booking/${id}/status`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateBookingChangeStatusRequest
    },
      options);
    }
  


export const getChangeBookingStatusMutationOptions = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeBookingStatus>>, TError,{id: number;data: BodyType<UpdateBookingChangeStatusRequest>}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationOptions<Awaited<ReturnType<typeof changeBookingStatus>>, TError,{id: number;data: BodyType<UpdateBookingChangeStatusRequest>}, TContext> => {
    
const mutationKey = ['changeBookingStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changeBookingStatus>>, {id: number;data: BodyType<UpdateBookingChangeStatusRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  changeBookingStatus(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChangeBookingStatusMutationResult = NonNullable<Awaited<ReturnType<typeof changeBookingStatus>>>
    export type ChangeBookingStatusMutationBody = BodyType<UpdateBookingChangeStatusRequest>
    export type ChangeBookingStatusMutationError = ErrorType<ApiAppError>

    /**
 * @summary Change Booking Status
 */
export const useChangeBookingStatus = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeBookingStatus>>, TError,{id: number;data: BodyType<UpdateBookingChangeStatusRequest>}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationResult<
        Awaited<ReturnType<typeof changeBookingStatus>>,
        TError,
        {id: number;data: BodyType<UpdateBookingChangeStatusRequest>},
        TContext
      > => {

      const mutationOptions = getChangeBookingStatusMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Update Booking Visit Information
 */
export const updateBookingVisitInformation = (
    id: number,
    updateBookingUpdateVisitInformationRequest: BodyType<UpdateBookingUpdateVisitInformationRequest>,
 options?: SecondParameter<typeof getApi>,) => {
      
      
      return getApi<UpdateBookingResponse>(
      {url: `/booking/${id}/visit_information`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateBookingUpdateVisitInformationRequest
    },
      options);
    }
  


export const getUpdateBookingVisitInformationMutationOptions = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBookingVisitInformation>>, TError,{id: number;data: BodyType<UpdateBookingUpdateVisitInformationRequest>}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationOptions<Awaited<ReturnType<typeof updateBookingVisitInformation>>, TError,{id: number;data: BodyType<UpdateBookingUpdateVisitInformationRequest>}, TContext> => {
    
const mutationKey = ['updateBookingVisitInformation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateBookingVisitInformation>>, {id: number;data: BodyType<UpdateBookingUpdateVisitInformationRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateBookingVisitInformation(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateBookingVisitInformationMutationResult = NonNullable<Awaited<ReturnType<typeof updateBookingVisitInformation>>>
    export type UpdateBookingVisitInformationMutationBody = BodyType<UpdateBookingUpdateVisitInformationRequest>
    export type UpdateBookingVisitInformationMutationError = ErrorType<ApiAppError>

    /**
 * @summary Update Booking Visit Information
 */
export const useUpdateBookingVisitInformation = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBookingVisitInformation>>, TError,{id: number;data: BodyType<UpdateBookingUpdateVisitInformationRequest>}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateBookingVisitInformation>>,
        TError,
        {id: number;data: BodyType<UpdateBookingUpdateVisitInformationRequest>},
        TContext
      > => {

      const mutationOptions = getUpdateBookingVisitInformationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get Bookings
 */
export const getBookings = (
    params?: GetBookingsParams,
 options?: SecondParameter<typeof getApi>,signal?: AbortSignal
) => {
      
      
      return getApi<GetBookingsResponse>(
      {url: `/bookings`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetBookingsQueryKey = (params?: GetBookingsParams,) => {
    return [`/bookings`, ...(params ? [params]: [])] as const;
    }

    
export const getGetBookingsQueryOptions = <TData = Awaited<ReturnType<typeof getBookings>>, TError = ErrorType<ApiAppError>>(params?: GetBookingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookings>>, TError, TData>>, request?: SecondParameter<typeof getApi>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBookingsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBookings>>> = ({ signal }) => getBookings(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBookings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBookingsQueryResult = NonNullable<Awaited<ReturnType<typeof getBookings>>>
export type GetBookingsQueryError = ErrorType<ApiAppError>


export function useGetBookings<TData = Awaited<ReturnType<typeof getBookings>>, TError = ErrorType<ApiAppError>>(
 params: undefined |  GetBookingsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBookings>>,
          TError,
          Awaited<ReturnType<typeof getBookings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApi>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBookings<TData = Awaited<ReturnType<typeof getBookings>>, TError = ErrorType<ApiAppError>>(
 params?: GetBookingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBookings>>,
          TError,
          Awaited<ReturnType<typeof getBookings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApi>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBookings<TData = Awaited<ReturnType<typeof getBookings>>, TError = ErrorType<ApiAppError>>(
 params?: GetBookingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookings>>, TError, TData>>, request?: SecondParameter<typeof getApi>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Bookings
 */

export function useGetBookings<TData = Awaited<ReturnType<typeof getBookings>>, TError = ErrorType<ApiAppError>>(
 params?: GetBookingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookings>>, TError, TData>>, request?: SecondParameter<typeof getApi>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBookingsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get Bookings
 */
export const prefetchGetBookings = async <TData = Awaited<ReturnType<typeof getBookings>>, TError = ErrorType<ApiAppError>>(
 queryClient: QueryClient, params?: GetBookingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookings>>, TError, TData>>, request?: SecondParameter<typeof getApi>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetBookingsQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}


/**
 * @summary Get previous and next bookings for a location
 */
export const getpreviousandnextbookingsforalocation = (
    locationId: string,
    currentBooking: number,
 options?: SecondParameter<typeof getApi>,signal?: AbortSignal
) => {
      
      
      return getApi<BrowseBookingResponse>(
      {url: `/bookings/browse/${locationId}/${currentBooking}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetpreviousandnextbookingsforalocationQueryKey = (locationId: string,
    currentBooking: number,) => {
    return [`/bookings/browse/${locationId}/${currentBooking}`] as const;
    }

    
export const getGetpreviousandnextbookingsforalocationQueryOptions = <TData = Awaited<ReturnType<typeof getpreviousandnextbookingsforalocation>>, TError = ErrorType<ApiAppError>>(locationId: string,
    currentBooking: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getpreviousandnextbookingsforalocation>>, TError, TData>>, request?: SecondParameter<typeof getApi>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetpreviousandnextbookingsforalocationQueryKey(locationId,currentBooking);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getpreviousandnextbookingsforalocation>>> = ({ signal }) => getpreviousandnextbookingsforalocation(locationId,currentBooking, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(locationId && currentBooking), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getpreviousandnextbookingsforalocation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetpreviousandnextbookingsforalocationQueryResult = NonNullable<Awaited<ReturnType<typeof getpreviousandnextbookingsforalocation>>>
export type GetpreviousandnextbookingsforalocationQueryError = ErrorType<ApiAppError>


export function useGetpreviousandnextbookingsforalocation<TData = Awaited<ReturnType<typeof getpreviousandnextbookingsforalocation>>, TError = ErrorType<ApiAppError>>(
 locationId: string,
    currentBooking: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getpreviousandnextbookingsforalocation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getpreviousandnextbookingsforalocation>>,
          TError,
          Awaited<ReturnType<typeof getpreviousandnextbookingsforalocation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApi>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetpreviousandnextbookingsforalocation<TData = Awaited<ReturnType<typeof getpreviousandnextbookingsforalocation>>, TError = ErrorType<ApiAppError>>(
 locationId: string,
    currentBooking: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getpreviousandnextbookingsforalocation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getpreviousandnextbookingsforalocation>>,
          TError,
          Awaited<ReturnType<typeof getpreviousandnextbookingsforalocation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApi>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetpreviousandnextbookingsforalocation<TData = Awaited<ReturnType<typeof getpreviousandnextbookingsforalocation>>, TError = ErrorType<ApiAppError>>(
 locationId: string,
    currentBooking: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getpreviousandnextbookingsforalocation>>, TError, TData>>, request?: SecondParameter<typeof getApi>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get previous and next bookings for a location
 */

export function useGetpreviousandnextbookingsforalocation<TData = Awaited<ReturnType<typeof getpreviousandnextbookingsforalocation>>, TError = ErrorType<ApiAppError>>(
 locationId: string,
    currentBooking: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getpreviousandnextbookingsforalocation>>, TError, TData>>, request?: SecondParameter<typeof getApi>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetpreviousandnextbookingsforalocationQueryOptions(locationId,currentBooking,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get previous and next bookings for a location
 */
export const prefetchGetpreviousandnextbookingsforalocation = async <TData = Awaited<ReturnType<typeof getpreviousandnextbookingsforalocation>>, TError = ErrorType<ApiAppError>>(
 queryClient: QueryClient, locationId: string,
    currentBooking: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getpreviousandnextbookingsforalocation>>, TError, TData>>, request?: SecondParameter<typeof getApi>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetpreviousandnextbookingsforalocationQueryOptions(locationId,currentBooking,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}


